import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';
import './WideOfferApplyButton.scss';
import { ReactComponent as LockIcon } from 'style/_assets/icons/lock-white.svg';
import { useConfig } from 'hook/config.hook';

const WideOfferApplyButton = ({
  datatestid,
  clickApplyHandler,
  partnerName,
  type,
  containerClassName,
  isFullPartnerName,
  hideIcon = false,
}) => {
  const containerClasses = classnames(
    'WideOfferButtonSection',
    'flex-column',
    'justify-center',
    { type: type },
    containerClassName,
  );
  const { config } = useConfig();
  const ctaDisclosure = isFullPartnerName
    ? partnerName
    : `on ${partnerName}'s ${config?.secureWebsiteDisclaimer}`;

  return (
    <FlexContainer className={containerClasses}>
      <Button
        className="applyNowButton"
        mrphType="primary"
        onClick={clickApplyHandler}
        datatestid={datatestid ? `${datatestid}-ApplyNowButton` : null}
      >
        <FlexContainer className="justify-center align-items-center ">
          {!hideIcon && (
            <LockIcon
              aria-hidden="true"
              className="lockIcon"
              style={{
                position: 'relative',
              }}
            />
          )}
          Continue
        </FlexContainer>
      </Button>
      <FlexContainer className="justify-end mobile-justify-center padT8">
        <div className="format100 text-center">
          <Label
            type="caption"
            color="fontGray300"
            datatestid={datatestid ? `${datatestid}-applyNowText` : null}
          >
            {ctaDisclosure}
          </Label>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export { WideOfferApplyButton };
